import React, { Component } from "react";
import { Typography, Icon, Button } from "antd";
import { Link, withRouter } from "react-router-dom";
import { signup } from "api/api";
import { displayGenericError } from "common/notifications";

import InputText from "components/InputText";
import OkModal from "components/modal/OkModal";
import { validatePassword, validateEmail } from "utils/utils";
import "./SignUpPage.scss";
import { Row, Col } from "antd/es/grid";
import Radio from "antd/lib/radio";
import SignUpModal from "../components/modal/SignUpModal";
import LoadingIndicator from "../components/LoadingIndicator";
import ClientTransferCalculatorSignUp from "../components/transfercalculator/ClientTransferCalculatorSignUp";

const { Text } = Typography;

class SignUpPage extends Component {
  state = {
    firstName: "",
    lastName: "",
    businessName:"",
    email: "",
    password: "",
    signupMessage: "",
    visible: false,
    signupVisible: false,
    customerAccountType:'PERSONAL',
    isLoading: false
  };

  handleCloseSignupModal = () => {
    this.setState({signupVisible: false});
  };

  _signUp = () => {
    const { firstName, lastName, email, password, businessName, customerAccountType } = this.state;
    if(this.state.customerAccountType === 'PERSONAL'){
      if (firstName.trim().length === 0) {
        displayGenericError({
          message: "Please input your Legal First Name"
        });
        return;
      }

      if (lastName.trim().length === 0) {
        displayGenericError({
          message: "Please input your Legal Last Name"
        });
        return;
      }
    }else{
      if (businessName.trim().length === 0) {
        displayGenericError({
          message: "Please input your Legal Business Name"
        });
        return;
      }
    }


    if (!validateEmail(email)) {
      displayGenericError({
        message: "Please check your email"
      });
      return;
    }

    if (!validatePassword(password)) {
      displayGenericError({
        message:
          "Your password must be have at least 8 characters with 1 uppercase and 1 lowercase"
      });
      return;
    }
    this.setState({
      isLoading:true
    })
    signup({ firstName, lastName, email, password, businessName, customerAccountType })
      .then(() => {
        this.setState({
          visible: true,
          signupMessage: "Please confirm your email",
          isLoading: false

        });
      })
        .catch(error => {
          displayGenericError(error);
          this.setState({
            isLoading:false
          })
        });
  };

  handleOk = () => {
    const { history } = this.props;
    history.push("/login?hide-signup-modal=true");
  };

  handleSignup = () => {
    this.setState({
      signupVisible:false,
      visible:true
    })
  };

  redirectLogin = () => {
    const { history } = this.props;
    history.push("/login");
  };

  onCustomerAccountTypeChange = (event) =>{

    this.setState({
      customerAccountType: event.target.value
    })
  }
  onPaymentChanged = newPayment => {
    this.setState({
      payment: newPayment
    });
  };
  render() {
    if (this.state.isLoading) {
      return <LoadingIndicator />;
    }
    return (
      <>
        <div className="sign-up-wrapper">

          <div className="right-panel">
            <div className="signup-page-body">
              <div> <ClientTransferCalculatorSignUp  transfer={this.state.payment}  onChange={this.onPaymentChanged} /></div>
              <br/>
              <Row gutter={23}>
                <Col lg={23} xs={23}>
                  <Button type="primary"
                    className="sign-up-button"
                    onClick={this.redirectLogin}
                  >
                  Get Started
                 </Button>
                </Col>
              </Row>
            </div>

            <div className="container-info">
              <div className="text-info">
                <Text className="text-primary">
                  <div>Hi,</div>
                  <div>
                    Welcome to Brdgx
                  </div>
                </Text>
                <h3 className={"describe"}>
                  We transfer money across the world <br/> quickly, simply and securely.
                </h3>
              </div>
              <Text className="text-copy-right">
                All rights reserved. Copyright 2020 Brdgx.
              </Text>
            </div>
          </div>
        </div>
        <OkModal
          message="Please verify your email address."
          visible={this.state.visible}
          handleOk={this.handleOk}
          title="Confirmation email is sent"
        />
        <SignUpModal
          visible={this.state.signupVisible}
          handleOk={this.handleSignup}
          onCancel={this.handleCloseSignupModal}
          title="Sign Up"
        />

      </>
    );
  }
}

export default withRouter(SignUpPage);
